import { Badge } from '../Badge';

interface TicketNumberBadgeProps {
  ticketNumber: string;
}

export const TicketNumberBadge = ({ ticketNumber }: TicketNumberBadgeProps) => (
  <Badge
    variant="outline"
    className="ticket-header-tag justify-center rounded-sm border px-2 text-xs leading-6 font-medium hover:bg-transparent"
  >
    {ticketNumber}
  </Badge>
);
